/**
 * Login settings (all public values) from .env:
 * - VITE_AUTH_DOMAIN     Managed Login domain of mdf-prod-users (later https://login.mdf.lu)
 * - VITE_AUTH_CLIENT_ID  app client mdf-prod-web
 * - VITE_API_BASE_URL    platform API (local: http://localhost:3000, later https://api-new.mdf.lu)
 */
export interface AuthConfig {
  domain: string;
  clientId: string;
  apiBaseUrl: string;
  /** Must be one of the app client's callback URLs. */
  redirectUri: string;
  /** Must be one of the app client's sign-out URLs. */
  logoutUri: string;
  scope: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`${name} is not set. Add it to .env (see .env.example).`);
  return value.replace(/\/+$/, "");
}

let cached: AuthConfig | null = null;

/** Read lazily so modules can be imported where .env is not available. */
export function authConfig(): AuthConfig {
  cached ??= {
    domain: required("VITE_AUTH_DOMAIN", import.meta.env.VITE_AUTH_DOMAIN),
    clientId: required("VITE_AUTH_CLIENT_ID", import.meta.env.VITE_AUTH_CLIENT_ID),
    apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
    redirectUri: `${window.location.origin}/auth/callback`,
    logoutUri: `${window.location.origin}/`,
    scope: "openid email profile",
  };
  return cached;
}
